const configSsams = {
  ssams: {
    listLayout: "SsamsListDefaultLayout",
    filterLayout: "SsamsFilterDefaultLayout",
    paginationLayout: "PaginationDefaultLayout",
    getFunc: "getSsams",
    listApiParamSet: {
      ip: 1,
    },
    pageRow: 10,
    paginationType: "pagination",
  },
  fixed: {
    listLayout: "SsamsListDefaultLayout",
    filterLayout: "SsamsFilterDefaultLayou",
    paginationLayout: "PaginationDefaultLayout",
    getFunc: "getSsams",
    listApiParamSet: {
      ip: 1,
    },
    pageRow: 10,
    paginationType: "pagination",
  },

  ssamsCreate: {
    writeLayouts: ["SsamsWriteDefaultLayout"],
    writeFunc: "createSsams",
    writeApiParamSet: {

    },
    parsingData: {
      memberKey: "mb_no",
      sequence: "s_seq",
      word: "s_one_word",
      memo: "s_memo",
      tag: "st_tag",
      sns:"sns",
      // todo!! uuid
      chatUuid:"s_uuid",
    },
    fileType: "ssams",
    isCategory: false,
    directUrl: "",
    directType: "back",
    writeSuccessType: 1,
    writeFailTypes: {
      "-1": "정보를 생성할 수 없습니다.",
      "-3": "없는 회원입니다.",
      "-800": "쌤즈회원입니다.",
      "-100": "필수값이 없습니다.",
      "-403": "권한이 없습니다.",
    },
    writeFailMsg: "작성에 실패하였습니다.",
  },

  ssamsUpdate: {
    writeLayouts: ["SsamsWriteDefaultLayout"],
    getFunc: "getSsams",
    detailApiParamsSet: {
      ip: 0,
    },
    writeFunc: "updateSsams",
    writeApiParamSet: {},
    parsingData: {
      ssamsKey: "s_idx",
      sequence: "s_seq",
      word: "s_one_word",
      memo: "s_memo",
      tag: "st_tag",
      sns:"sns",
      chatUuid:"s_uuid",
    },
    directUrl: "",
    directType: "back",
    fileType: "ssams",
    isCategory: false,
    writeSuccessType: 1,
    writeFailTypes: {
      "-1": "정보를 수정할 수 없습니다.",
      "-100": "필수값이 없습니다.",
      "-403": "권한이 없습니다.",
      "-404": "쌤즈 회원이 없습니다.",
    },
    keyName: "s_idx",
    deleteFunc: "deleteSsams",
    deleteApiParamsSet: {},
    deleteSuccessType: 1,
    deleteFailTypes: {
      "-1": "정보를 삭제할 수 없습니다.",
      "-100": "필수값이 없습니다.",
      "-403": "권한이 없습니다.",
      "-404": "쌤즈 회원이 없습니다.",
    },
  },
  ssamsFix: {
    listLayout: "BoardListSsamsContentLayout",
    filterLayout: "",
    paginationLayout: "",
    getFunc: "getSsamsFix",
    parsingData: {
      wid: "wr_id",
      sid: "s_idx",
    },
    deleteFunc: "deleteNotice",
    paginationType: "pagination",
    listApiParamSet: {
    },
    deleteApiParamsSet: {
      type: "post",
    },
    deleteSuccessType: 1,
    deleteFailTypes: {},
    deleteErrorTypes: {},
    keyName: "s_idx",
  },
  ssamsContentFix : {
    listLayout: "BoardListSsamsContentLayout",
    filterLayout: "BoardFilterSsamsContentLayout",
    paginationLayout: "PaginationDefaultLayout",
    getFunc: "getSsamsContent",
    paginationType: "pagination",
    listApiParamSet: {
      ip: 1,
      type: "post",
      wr: 1,
    },
    pageRow: 10,
    keyName: "s_idx",
    writeLayouts: ["SsamsFixLayout"],
    writeFunc: "createContentFix",
    deleteFunc: "deleteContentFix",
    writeApiParamSet: {
      // wid: "wr_id",
      // sid: "s_idx",
      wr_id : 'wr_id',
      s_idx : 's_idx',
    },
    parsingData : {
      wid: "wr_id",
      sid: "s_idx",
    },
    writeSuccessType: 1,
    directUrl: "",
    directType: "back",
  },
  ssamsKoreanTalkFix : {
    listLayout: "BoardListSsamsContentLayout",
    filterLayout: "BoardFilterSsamsContentLayout",
    paginationLayout: "PaginationDefaultLayout",
    getFunc: "getSsamsKoreanTalk",
    paginationType: "pagination",
    listApiParamSet: {
      ip: 1,
      type: "post",
      wr: 1,
    },
    pageRow: 10,
    writeLayouts: ["SsamsFixLayout"],
    writeFunc: "createKoreantalkFix",
    deleteFunc: "deleteKoreantalkFix",
    writeApiParamSet: {

      wr_id : 'wr_id',
      s_idx : 's_idx',
    },
    parsingData : {
      wid: "wr_id",
      sid: "s_idx",
    },
    writeSuccessType: 1,
    directType: "back",
    keyName : 's_idx'
  },
  ssamsLiveClass: {
    listLayout: "SsamsListLiveKlassLayout",
    filterLayout: "SsamsFilterDefaultLayout",
    paginationLayout: "PaginationDefaultLayout",
    getFunc: "getSsams",
    listApiParamSet: {
      ip: 1,
      // live : 1,
    },
    pageRow: 10,
    paginationType: "pagination",
  },
};

export default {
  methods: {
    returnSsamsConfig(type) {
      return configSsams[type];
    },
  },
  filterConfig: {
    cr: {
      type: "between",
      classname: "filterDate",
    },
    ni: {
      type: "query",
      classname: "searchInput",
    },
    mid: {
      type: "query",
      classname: "searchInput",
    },
    su: {
      type: "query",
      classname: "searchInput",
    },
    mbni: {
      //유저콘텐츠, 1:1문의 작성자 닉네임
      type: "query",
      classname: "searchInput",
    },
  },
};
